import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography
} from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { markStepComplete } from "../../../api/onboardApi";
import {LEAD_TYPES, PHONE_TYPES} from "../../../constants/CoreConstants";
import useQueryParam from "../../../hooks/useQueryParam";
import { BasicMaskedInput } from "../../GlobalAddDealModalV3/GlobalAddDealModalStyles";
import GlobalModalV2 from "../../GlobalModal/Modal/GlobalModalV2";
import BasicInput from "../../custom/BasicInput";
import BasicSelect from "../../custom/BasicSelect";
import { CustomFieldType, US_STATE_LIST } from "../CoreConstants";
import { IconList } from "../IconList";
import Upgrade from "../Upgrade";
import Utils, { getState } from "../Utils";
import {
  getUserCustomFieldList,
  getUserSourceList,
  getUserTagList,
  setUserCustomFieldList,
  setUserSourceList,
  setUserTagList,
  storeUserCustomFieldsListNew,
} from "../addContactAction";
import { addBusinessPrimaryContact, getContactLimit, getZipCodeByPlace, submitSingleContactV2, } from "../contactApi";
import "./../addContact.css";
import { BasicInputSelect, useStyles, } from "./AddContactModalV2Styles";
import GlobalAddContactModalSkeleton from "./GlobalAddContactModalSkeleton";
import LeadType from "./LeadType";
import BasicFormControlWithLabelV2 from "../../custom/BasicFormControlWithLabelV2";
const GOOGLE_API_KEY = process.env.REACT_APP_MAP_KEY;

const AddContactModal = (props) => {
  const history = useHistory();
  const [contactForm, setContactForm] = useState({
    selected_source: "",
    lead_type: "",
    first_name: "",
    last_name: "",
    numbers: [{ number: "", number_state: "mobile" }],
    emails: [{ email: "" }],
    company_name: props.data?.contactDetails?.company_name || "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    url: "",
    deal_value: 0,
    birth_day: "",
    anniversary_date: "",
  });

  const [firstLoading, setFirstLoading] = useState(true);
  const [leadSources, setLeadSources] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldsData, setCustomFieldsData] = useState([]);
  const [submittingContact, setSubmittingContact] = useState(false);
  const [birthDate, setBirthDate] = useState(null);
  const [anniversaryDate, setAnniversaryDate] = useState(null);
  const [value, setValue] = useState(null);
  const [contactLimit, setContactLimit] = useState(0);
  const [currentContact, setCurrentContact] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showAddress, setShowAddress] = useState(false);

  const [additionalDates, setAdditionalDates] = useState([]);
  const [additionalDatesErrors, setAdditionalDatesErrors] = useState([]);
  const openTab = useQueryParam("open-tab");
  const from = useQueryParam("from");

  useEffect(() => {
    if (firstLoading) {
      setIsLoading(true);
      setFirstLoading(false);

      getContactLimit().then((res) => {
        setIsLoading(false);
        let data = res.data.data;
        if (data.contactLimit > data.currentContact) {
          fetchSourceInfos().then();
          fetchUserCustomFields().then();
        }
        if (data.contactLimit) {
          setContactLimit(data.contactLimit);
          setCurrentContact(data.currentContact);
        }
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let tempCustomData = [...customFields];
    setCustomFields(tempCustomData);
  }, [customFieldsData]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchSourceInfos = async () => {
    if (props.storedSourceList !== null) {
      setLeadSources(props.storedSourceList);
    } else if (props.data?.sourceList !== undefined && props.data?.sourceList != null) {
      setLeadSources(props.data.sourceList);
    } else {
      await props.fetchUserSourceList({}, (callback) => {
        setLeadSources(callback);
      });
    }
  };

  const fetchUserCustomFields = async () => {
    if (props.storedCustomField !== null) {
      setCustomFields(props.storedCustomField);
    } else {
      window
        .globalCustomFieldWithPersonalized({
          get_custom_data: true,
          get_personalized_data: false,
          field_name: ["*"],
          for_drop_down: false,
          drop_down_field: {
            value_field: "id",
            title_field: "title",
          },
        })
        .then((res) => {
          let customFieldDatas = res.data.custom_field;
          let customFieldValues = [];
          customFieldDatas.forEach((row, index) => {
            customFieldValues.push(null);
          });
          setCustomFields(customFieldDatas);
          setCustomFieldsData(customFieldValues);
          props.storeUserCustomFieldsNew(customFieldDatas);
        });
    }
  };

  const handleSelectChange = (value) => {
    setContactForm({ ...contactForm, selected_source: value });
  };

  const handleInputField = (field, value) => {
    let tempContactForm = { ...contactForm };
    tempContactForm[field] = value;
    setContactForm(tempContactForm);
  };

  const handleAddress = async (event) => {
    let placeId =
      event.place_id !== undefined && event.place_id != null
        ? event.place_id
        : null;
    let zip = "";
    let road = "";
    let streetNumber = "";
    let state = "";
    let city = "";
    let country = "";
    let county = "";
    if (placeId != null) {
      try {
        await getZipCodeByPlace({
          placeId: placeId,
          googleAPIKey: GOOGLE_API_KEY,
        }).then((res) => {
          try {
            if (
              res.data.data.result.formatted_address !== undefined &&
              res.data.data.result.formatted_address != null
            ) {
              let data_array =
                res.data.data.result.formatted_address.split(",");
              if (data_array.length === 4) {
                let state_zip = data_array[2].trim().split(" ");
                setContactForm({
                  ...contactForm,
                  address: data_array[0].trim(),
                  city: data_array[1].trim(),
                  state: state_zip[0],
                  country: data_array[3],
                  zip: state_zip[1],
                });
              } else {
                zip = res?.data?.zip;
                if (
                  res.data.data.result.address_components &&
                  Array.isArray(res.data.data.result.address_components)
                ) {
                  res.data.data.result.address_components.map((item, index) => {
                    if (item.types[0] === "street_number") {
                      streetNumber = item.long_name;
                    } else if (item.types[0] === "route") {
                      road = item.long_name;
                    } else if (
                      item.types[0] === "administrative_area_level_1"
                    ) {
                      state = item.short_name;
                    } else if (
                      item.types[0] === "administrative_area_level_2"
                    ) {
                      city = item.long_name;
                    } else if (item.types[0] === "country") {
                      country = item.long_name;
                    } else if (item.types[0] === "postal_code") {
                      zip = item.long_name;
                    } else if (
                      item.types[0] === "administrative_area_level_3"
                    ) {
                      county = item.long_name;
                    }
                    setContactForm({
                      ...contactForm,
                      address: streetNumber + " " + road,
                      city: county !== "" ? county : city,
                      state: state,
                      country: country,
                      zip: zip,
                    });
                  });
                } else {
                  updateContactInfo(event, zip);
                }
              }
            } else {
              zip = res?.data?.zip;
              if (
                res.data.data.result.address_components &&
                Array.isArray(res.data.data.result.address_components)
              ) {
                res.data.data.result.address_components.map((item, index) => {
                  if (item.types[0] === "street_number") {
                    streetNumber = item.long_name;
                  } else if (item.types[0] === "route") {
                    road = item.long_name;
                  } else if (item.types[0] === "administrative_area_level_1") {
                    state = item.short_name;
                  } else if (item.types[0] === "administrative_area_level_2") {
                    city = item.long_name;
                  } else if (item.types[0] === "country") {
                    country = item.long_name;
                  } else if (item.types[0] === "postal_code") {
                    zip = item.long_name;
                  } else if (item.types[0] === "administrative_area_level_3") {
                    county = item.long_name;
                  }
                  setContactForm({
                    ...contactForm,
                    address: streetNumber + " " + road,
                    city: county !== "" ? county : city,
                    state: state,
                    country: country,
                    zip: zip,
                  });
                });
              } else {
                updateContactInfo(event, zip);
              }
            }
          } catch (error) {
            zip = res?.data?.zip;
            if (
              res.data.data.result.address_components &&
              Array.isArray(res.data.data.result.address_components)
            ) {
              res.data.data.result.address_components.map((item, index) => {
                if (item.types[0] === "street_number") {
                  streetNumber = item.long_name;
                } else if (item.types[0] === "route") {
                  road = item.long_name;
                } else if (item.types[0] === "administrative_area_level_1") {
                  state = item.short_name;
                } else if (item.types[0] === "administrative_area_level_2") {
                  city = item.long_name;
                } else if (item.types[0] === "country") {
                  country = item.long_name;
                } else if (item.types[0] === "postal_code") {
                  zip = item.long_name;
                } else if (item.types[0] === "administrative_area_level_3") {
                  county = item.long_name;
                }
                setContactForm({
                  ...contactForm,
                  address: streetNumber + " " + road,
                  city: county !== "" ? county : city,
                  state: state,
                  country: country,
                  zip: zip,
                });
              });
            } else {
              updateContactInfo(event, zip);
            }
          }
        });
      } catch (e) {
        updateContactInfo(event, "");
        console.log(e);
      }
    }
  };

  const updateContactInfo = (event, zip) => {
    let fullAddressArr = event.description.split(",");
    let address =
      fullAddressArr[0] !== undefined ? fullAddressArr[0].trim() : "";
    let city = fullAddressArr[1] !== undefined ? fullAddressArr[1].trim() : "";
    let fullState =
      fullAddressArr[2] !== undefined ? fullAddressArr[2].trim() : "";
    let country =
      fullAddressArr[3] !== undefined ? fullAddressArr[3].trim() : "";

    let stateArr = fullState.split(" ");
    let state = stateArr[0] !== undefined ? stateArr[0].trim() : "";

    setContactForm({
      ...contactForm,
      address: address,
      city: city,
      state: state,
      country: country,
      zip: zip,
    });
  };

  const handleCustomFieldChange = (
    value,
    index_field,
    id,
    maxLength = null
  ) => {
    if ((maxLength != null) & (value.length > maxLength)) {
      return false;
    }

    let previousData = [...customFieldsData];
    if (value === "") {
      previousData[index_field] = null;
    } else {
      previousData[index_field] = {
        user_custom_field_id: id,
        value: value,
      };
    }
    setCustomFieldsData(previousData);
  };

  const isDateInvalid = (birth, anniversary) => {
    let birthDate = moment(birth).isValid();
    let anniversaryDate = moment(anniversary).isValid();

    if ((birth && anniversary) || birth || anniversary) {
      if (
        (birthDate && anniversaryDate) ||
        (birthDate && anniversary == null) ||
        (anniversaryDate && birth == null)
      ) {
        return false;
      } else {
        if (
          !birthDate &&
          anniversary != null &&
          !anniversaryDate &&
          birth != null
        ) {
          return "Both Birth & Anniversary Date are Invalid!";
        } else if (!birthDate && !birthDate && birth != null) {
          return "Birthdate is Invalid!";
        } else if (
          !anniversaryDate &&
          !anniversaryDate &&
          anniversary != null
        ) {
          return "Anniversary Date is Invalid!";
        } else {
          return "Date is Invalid!";
        }
      }
    } else {
      return false;
    }
  };


  const addImportantDatesField = () => {
    const tempAdditionalDates = [...additionalDates];
    let newObj = {
      type: "CUSTOM",
      title: "",
      value: ""
    };
    tempAdditionalDates.push(newObj);
    setAdditionalDates(tempAdditionalDates);
  };

  const removeInputField = (index) => {
    const tempAdditionalDates = [...additionalDates];
    tempAdditionalDates.splice(index, 1);
    setAdditionalDates(tempAdditionalDates);
  };

  const removeMultiField = (field, index) => {
    let tempContactForm = { ...contactForm };
    let tempFieldNumbers = [...tempContactForm[field]];
    tempFieldNumbers.splice(index, 1);
    tempContactForm[field] = tempFieldNumbers;
    setContactForm(tempContactForm);
  };

  const handleChangeInputField = (key, value, index) => {
    const tempAdditionalDates = [...additionalDates];
    tempAdditionalDates[index][key] = value;
    setAdditionalDates(tempAdditionalDates);


    if (additionalDatesErrors[index] && additionalDatesErrors[index][key]) {
      const tempAdditionalDatesErrors = [...additionalDatesErrors];
      tempAdditionalDatesErrors[index][key] = "";
      setAdditionalDatesErrors(tempAdditionalDatesErrors);
    }
  };

  const validateFields = () => {
    let isValid = true;

    let additionalErrors = [];

    additionalDates.forEach((additionalDate) => {
      let err = {
        title: "",
        value: ""
      };
      if (additionalDate.title !== null && additionalDate.title !== undefined && additionalDate.title.trim() === "") {
        err.title = "Date title is required";
        window.showNotification('Error', 'Important date title cannot be empty');
        isValid = false;
      }

      if (additionalDate.value !== null && additionalDate.value !== undefined && additionalDate.value.trim() === "") {
        err.value = "Date is required";
        window.showNotification('Error', 'Important date value cannot be empty');
        isValid = false;
      }

      additionalErrors.push(err);
    });
    setAdditionalDatesErrors(additionalErrors);
    return isValid;
  };

  const isInvalidFields = (field) => {
    let hasInvalid = false;
    if (field === 'number') {
      const tempContactForm = { ...contactForm };
      const tempFieldData = [...tempContactForm['numbers']];
      tempFieldData.forEach((additionalNumber) => {
        if (additionalNumber['number'] !== '' && !Utils.validateMobileNumber(additionalNumber['number'])) {
          hasInvalid = true;
        }
      });

    } else {
      const tempContactForm = { ...contactForm };
      const tempFieldData = [...tempContactForm['emails']];
      tempFieldData.forEach((additionalEmail) => {
        if (additionalEmail['email'] !== '' && !Utils.validateEmail(additionalEmail['email'])) {
          hasInvalid = true;
        }
      });
    }
    return hasInvalid;
  }

  const haveRequiredFields = () => {
    let hasNumber = false;
    let hasEmail = false;

    const tempContactForm = { ...contactForm };
    const tempFieldData = [...tempContactForm['numbers']];
    tempFieldData.forEach((additionalNumber, index) => {
      if (index === 0 && additionalNumber['number'] !== '') {
        hasNumber = true;
      }
    });

    const tempFieldEmailData = [...tempContactForm['emails']];
    tempFieldEmailData.forEach((additionalEmail, index) => {
      if (index === 0 && additionalEmail['email'] !== '') {
        hasEmail = true;
      }
    });

    if (hasNumber || hasEmail) {
      return true;
    } else {
      return false;
    }
  }

  const addContactCallback = (showModal = null, success = null, contactId = '') => {
    if (showModal !== undefined && showModal != null) {
      props.onClose();
    }
    if (success !== undefined && success != null && success) {
      if (contactId !== '') {
        history.push('/contacts/' + contactId)
      }
    }
  }

  const submitNewContact = async () => {
    let validation = isDateInvalid(birthDate, anniversaryDate);
    if (validation) {
      window.showNotification('Error', validation);
      return;
    }

    if (!validateFields()) return;

    if (!haveRequiredFields()) {
      window.showNotification('Error', 'Email and Number, Either of them are necessary');
    } else if (isInvalidFields('email')) {
      window.showNotification('Error', 'Email is Invalid!');
    }
    else if (isInvalidFields('number')) {
      window.showNotification('Error', 'Number is Invalid!');

    } else {
      let tempContactForm = { ...contactForm };
      tempContactForm['customFields'] = customFieldsData;
      tempContactForm['important_dates'] = additionalDates;
      try {
        if(props.data?.addPrimaryContact && props.data?.contactDetails) {
          tempContactForm['business_contact_id'] = props?.data?.contactDetails?.id
         try {
            const response = await addBusinessPrimaryContact(tempContactForm);
            if (response.success) {
              props.onClose();
              props.data?.handleCallBack();
              window.showNotification('SUCCESS', response.message);
            } else {
              window.showNotification('Error', response.message);
            }
          } catch (error) {
            console.error('Error adding primary contact:', error);
            window.showNotification('Error', 'An unexpected error occurred.');
          } finally {
            setSubmittingContact(false);
          }
        } else {
        submitSingleContactV2(tempContactForm)
          .then(response => {
            if (response.data.messageStatus === 'error') {
              window.showNotification('Error', response.data.html.email !== undefined ? response.data.html.email :
                response.data.html.number !== undefined ? response.data.html.number : 'Something went wrong');

              setSubmittingContact(false)

            } else {
              if (openTab === "CREATE_CONTACT" && from === "onboard"){
                markStepComplete({ key: "CREATE_CONTACT" })
                    .then((resp)=>{})
                    .catch((err)=>{})
                    .finally(()=>{
                      window.showNotification('SUCCESS', 'Contact added successfully!');
                      // props.refreshDataForUpdateContact()
                      addContactCallback(false, true, response.data.insertedContactId);
                      setSubmittingContact(false)
                    });
              }else {
                window.showNotification('SUCCESS', 'Contact added successfully!');
                // props.refreshDataForUpdateContact()
                addContactCallback(false, true, response.data.insertedContactId);
                setSubmittingContact(false)
              }
            }
          })
        }
      } catch (e) {
        console.log(e)
        setSubmittingContact(false)
      }
    }
  };

  const toggleAddress = () => {
    setShowAddress((prev) => !prev);
  };

  const appendEmail = () => {
    const emailObj = {
      email: ""
    };
    const tempContactForm = { ...contactForm };
    tempContactForm.emails.push(emailObj);
    setContactForm(tempContactForm);
  };

  const appendNumber = () => {
    const numberObj = {
      number: "",
      number_state: "mobile",
    };
    const tempContactForm = { ...contactForm };
    tempContactForm.numbers.push(numberObj);
    setContactForm(tempContactForm);
  };

  const handleChangeDynamicInput = (field, key, value, index) => {
    if (field === 'numbers' && key=== 'number') {
      if (!Utils.checkLetterExistInText(value) || value === '') {
        if (value.length > 0 && value[0] !== '1') {
          value = 1 + value;
        }
      } else {
        try {
          value = value.replace(/[^0-9]+/g, '')
          if (value.length > 0 && value[0] !== '1') {
            value = 1 + value;
          }
        }
        catch (e) {
          console.log(e)
        }
      }

      if (value.length > 11) {
        value = value.slice(0, 11);
      }
    }
    const tempContactForm = { ...contactForm };
    const tempFieldData = [...tempContactForm[field]];
    tempFieldData[index][key] = value;
    tempContactForm[field] = tempFieldData;
    setContactForm(tempContactForm);
  };

  const makeAddress = () => {
    let address = "";

    address = contactForm.address;

    if (contactForm.city) {
      if (address) {
        address += " ";
      }
      address += contactForm.city;
    }

    if (contactForm.state) {
      if (address) {
        address += " ";
      }
      address += contactForm.state;
    }

    if (contactForm.country) {
      if (address) {
        address += " ";
      }
      address += contactForm.country;
    }

    if (contactForm.zip) {
      if (address) {
        address += " ";
      }
      address += contactForm.zip;
    }

    return address;
  }

  const classes = useStyles();
  const placeholderColor = "#929da9";
  const activeColor = "#36454F";
  const placeholderColorForDate= "rgb(8 40 82 / 42%)";
  const imgSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/smart_list/1.0.0/smart_lists_icon.png`
  return (
    <GlobalModalV2
      open={props.open}
      title={
        <div className={classes.titleContainer}>
          <div className={classes.logoContainer}>
          <img src={imgSrc} alt="logo" className={classes.logo} />
          </div> 
          <h2 style={{ color: "#000" }}>New Contact</h2>
        </div>
      }
      onClose={props.onClose}
      buttonText={"Save"}
      hideFooter={currentContact >= contactLimit ? true : submittingContact}
      handleSubmit={submitNewContact}
      className={"global-large-modal main-add-contact-modal main-add-contact-modal-v2"}
    >
      {!isLoading && (
        <Fragment>
          {currentContact < contactLimit && (
            <div className="add-contact-content-body awesome__scroll_bar" style={{paddingBottom: "38px",overflowX:'hidden'}}>
              <Box mb={2} pt={2}>
                <Grid container spacing={2} style={{ paddingInline: 5 }}>
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                      style={{ border: "none", padding: 0 }}
                    >
                        <BasicFormControlWithLabelV2
                            label={' Lead Source'}
                            fullWidth
                            component={
                                <BasicSelect
                                    fullWidth
                                    name="leadSource"
                                    options={leadSources}
                                    defaultText="Select lead source"
                                    value={contactForm.selected_source}
                                    onChange={(e) => handleSelectChange(e.target.value)}
                                    mapping={{
                                        label: "source_title",
                                        value: "id"
                                    }}
                                />
                            }
                            sx={{
                                '& .MuiInputBase-root': {
                                    marginTop: 0,
                                },
                                '& .MuiInputBase-input': {
                                    border: 'none !important'
                                }
                            }}
                        />
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      }}
                    >
                      <LeadType
                        leadType={contactForm.lead_type}
                        onChange={handleInputField}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                      <BasicFormControlWithLabelV2
                          label={'Company Name (Optional)'}
                          fullWidth
                          component={
                              <BasicInput
                                  fullWidth
                                  placeholder="Enter Company Name"
                                  value={contactForm.company_name}
                                  onChange={(event) => handleInputField("company_name", event.target.value)}
                              />
                          }
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>

                  <Grid item xs={6}>
                      <BasicFormControlWithLabelV2
                          label={'First Name'}
                          fullWidth
                          component={
                              <BasicInput
                                  fullWidth
                                  placeholder="Enter First Name"
                                  value={contactForm.first_name}
                                  onChange={(event) => handleInputField("first_name", event.target.value)}
                              />
                          }
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>

                  <Grid item xs={6}>
                      <BasicFormControlWithLabelV2
                          label={'Last Name'}
                          fullWidth
                          component={
                              <BasicInput
                                  fullWidth
                                  placeholder="Enter Last Name"
                                  value={contactForm.last_name}
                                  onChange={(event) => handleInputField("last_name", event.target.value)}
                              />
                          }
                          sx={{
                              '& .MuiInputBase-root': {
                                  marginTop: 0,
                              },
                              '& input': {
                                  border: 'none !important'
                              }
                          }}
                      />
                  </Grid>

                  {
                    contactForm.numbers.map((number, index) => (
                      <Grid item xs={12} key={index}>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} className="mask-numbr-input">
                                <BasicFormControlWithLabelV2
                                    label={'Phone Number'}
                                    fullWidth
                                    component={
                                        <BasicMaskedInput
                                            mask={['+', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                            className={`${classes.phoneNumberInput} MuiInputBase-input`}
                                            placeholder="Enter Phone Number"
                                            // guide={true}
                                            // keepCharPositions={true}
                                            id={"number-input-field" + index}
                                            onChange={(event) => { handleChangeDynamicInput("numbers", "number", event.target.value, index); }}
                                            value={number.number}
                                        />
                                    }
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            marginTop: 0,
                                        },
                                        '& input': {
                                            border: 'none !important'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                              <Box style={{ border: "none", padding: 0 }}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                <BasicSelect
                                    fullWidth
                                    name="numberState"
                                    options={PHONE_TYPES}
                                    value={number.number_state}
                                    onChange={(event) => { handleChangeDynamicInput("numbers", "number_state", event.target.value, index); }}
                                    mapping={{
                                      label: "label",
                                      value: "value"
                                    }}
                                />
                                  {index === 0 ? (
                                    <div className={classes.addButtonStyle} onClick={appendNumber}>
                                      {IconList.plusBoldSVG}
                                    </div>
                                  )
                                    :
                                    (
                                      <IconButton
                                        size='small'
                                        className=""
                                        style={{ marginLeft: "5px" }}
                                        onClick={() => {
                                          removeMultiField("numbers", index);
                                        }}
                                      >
                                        <DeleteForever color='error' />
                                      </IconButton>
                                    )
                                  }

                                </div>

                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}

                  {
                    contactForm.emails.map((email, index) => (
                      <Grid item xs={12} key={index}>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <BasicFormControlWithLabelV2
                                label={'Email Address'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        placeholder="Email Address"
                                        value={email.email}
                                        onChange={(event) => { handleChangeDynamicInput("emails", "email", event.target.value, index); }}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                          {index === 0 ? (
                            <div className={classes.addButtonStyle} onClick={appendEmail}>
                              {IconList.plusBoldSVG}
                            </div>
                          )
                            :
                            (
                              <IconButton
                                size='small'
                                className=""
                                style={{ marginLeft: "5px" }}
                                onClick={() => {
                                  removeMultiField("emails", index);
                                }}
                              >
                                <DeleteForever color='error' />
                              </IconButton>
                            )
                          }
                        </div>
                      </Grid>
                    ))
                  }

                  {
                    showAddress ? (
                      <Grid item xs={12} style={{ paddingBottom: 0 }}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "2px" }}>
                          <Button
                            variant="contained"
                            className={classes.manualEntryButton}
                            onClick={toggleAddress}
                            style={{ margin: 0, padding: "6px 14px", textTransform: "none", marginBottom: "10px" }}
                          >
                            Address Search
                          </Button>
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item xs={12}>
                        <Box className={classes.googlePlacesAutocomplete} style={{ margin: 0 }}>
                          <Box sx={{ display: "flex", justifyContent: "center", gap: "10px", paddingTop: "4px" }}>
                            <div style={{ width: "100%" }}>
                                <BasicFormControlWithLabelV2
                                    label={'Address Search'}
                                    fullWidth
                                    component={
                                        <GooglePlacesAutocomplete
                                            apiKey={GOOGLE_API_KEY}
                                            autoFocus={false}
                                            autocompletionRequest={{
                                                componentRestrictions: {
                                                    country: ["us", "ca"],
                                                },
                                            }}
                                            selectProps={{
                                                value,
                                                onChange: async (e) => {
                                                    await handleAddress(e.value);
                                                },
                                                placeholder: <span style={{ color: "rgb(8 40 82 / 42%)",fontSize:"15px" }}>Start typing address here…</span>,
                                                classNamePrefix: "my-google-places-autocomplete",
                                            }}
                                        />
                                    }
                                    sx={{
                                        '& .my-google-places-autocomplete__control': {
                                            border: 'none !important'
                                        },
                                        '& .my-google-places-autocomplete__control--is-focused, .my-google-places-autocomplete__control--menu-is-open' : {
                                            boxShadow: 'none !important'
                                        }
                                    }}
                                />
                            </div>
                            <div style={{ width: "2px", paddingTop: "8px" }}>
                              <span style={{ position: "relative", marginLeft: "-80px" }}>
                                {IconList.locationSVG}
                              </span>
                            </div>

                            <Button
                              variant="contained"
                              className={classes.manualEntryButton}
                              onClick={toggleAddress}
                              style={{ whiteSpace: "nowrap", paddingLeft: "14px", paddingRight: "14px", textTransform: "none" }}
                            >
                              Manual
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                    )
                  }
                  {
                    showAddress ? (
                      <Fragment>
                        <Grid item xs={12} style={{ paddingTop: "0px" }}>
                            <BasicFormControlWithLabelV2
                                label={'Address'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        placeholder="Enter Address"
                                        value={contactForm.address}
                                        onChange={(event) => handleInputField("address", event.target.value)}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <BasicFormControlWithLabelV2
                                label={'City'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        placeholder="Enter City"
                                        value={contactForm.city}
                                        onChange={(event) => handleInputField("city", event.target.value)}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={6}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                              <BasicFormControlWithLabelV2
                                  label={'State'}
                                  fullWidth
                                  component={
                                    <BasicSelect
                                        name="state"
                                        defaultText="Please Select"
                                        options={US_STATE_LIST}
                                        value={getState(contactForm.state) ? contactForm.state : ""}
                                        onChange={(event) => {
                                            handleInputField("state", event.target.value)
                                        }}
                                        mapping={{
                                            label: "label",
                                            value: "value",
                                        }}
                                    />
                                  }
                                  sx={{
                                      '& .MuiInputBase-root': {
                                          marginTop: 0,
                                      },
                                      '& .MuiInputBase-input': {
                                          border: 'none !important'
                                      }
                                  }}
                              />
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <BasicFormControlWithLabelV2
                                label={'Country'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        placeholder="Enter Country"
                                        value={contactForm.country}
                                        onChange={(event) => handleInputField("country", event.target.value)}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <BasicFormControlWithLabelV2
                                label={'Zip Code'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        placeholder="Enter Zip Code"
                                        value={contactForm.zip}
                                        onChange={(event) => handleInputField("zip", event.target.value)}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                        </Grid>
                      </Fragment>
                    ) : (
                      <Grid item xs={12} style={{ paddingTop: 0 }}>
                        <div style={{ fontSize: "12px" }}>{makeAddress()}</div>
                      </Grid>
                    )
                  }
                </Grid>
              </Box>

              <Box mb={0}>
                <Box mb={0} style={{ border: "none", padding: "0px" }}>
                  <div style={{padding: "0px 6px"}}>
                  <Box className={classes.headlineWrapper}>
                    <Typography variant="body1">
                      Additional Info
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      columnGap: 20,
                    }}
                  >
                    {
                      customFields &&
                      Array.isArray(customFields) &&
                      customFields.map((each, index) => {
                        return renderEachCustomField(
                          each,
                          index,
                          handleCustomFieldChange,
                          customFieldsData
                        );
                      })
                    }
                  </Box>
                  </div>

                  {/* // Dates */}
                  <Grid container spacing={2} style={{ paddingInline: 5, marginTop: "2px" }}>
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          flex: 1,
                        }}
                      >
                          <BasicFormControlWithLabelV2
                              label={'Birthday'}
                              fullWidth
                              component={
                                  <BasicInput
                                      fullWidth
                                      type="date"
                                      style={{color:`${(
                                              !birthDate) ?
                                              placeholderColorForDate : activeColor }`
                                      }}
                                      name="birth_date"
                                      onChange={(e) => {
                                          setBirthDate(e.target.value);
                                          handleInputField("birth_date", e.target.value);
                                      }}
                                  />
                              }
                              sx={{
                                  '& .MuiInputBase-root': {
                                      marginTop: 0,
                                  },
                                  '& input': {
                                      border: 'none !important'
                                  }
                              }}
                          />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          flex: 1,
                        }}
                      >
                        <div style={{ display: "flex", gap: "10px" }}>
                            <BasicFormControlWithLabelV2
                                label={'Anniversary'}
                                fullWidth
                                component={
                                    <BasicInput
                                        fullWidth
                                        type="date"
                                        style={{color:`${(
                                                !anniversaryDate) ?
                                                placeholderColorForDate : activeColor }`
                                        }}
                                        name="anniversary_date"
                                        onChange={(e) => {
                                            setAnniversaryDate(e.target.value);
                                            handleInputField("anniversary_date", e.target.value);
                                        }}
                                    />
                                }
                                sx={{
                                    '& .MuiInputBase-root': {
                                        marginTop: 0,
                                    },
                                    '& input': {
                                        border: 'none !important'
                                    }
                                }}
                            />
                          <div className={classes.addButtonStyle} onClick={addImportantDatesField}>
                            {IconList.plusBoldSVG}
                          </div>
                        </div>
                      </Box>
                    </Grid>
                    {
                      additionalDates.map((additionalDate, index) => (
                        <>
                          <Grid item xs={12} md={6} >
                            <Box className={classes.flexColumn} sx={{ gap: 5, flex: 1 }} style={{ border: "none", padding: 0, marginTop: "0px" }}>
                              <BasicInput
                                fullWidth
                                type='text'
                                value={additionalDate.title}
                                placeholder={'Add a title here'}
                                onChange={(event) => { handleChangeInputField('title', event.target.value, index) }}
                              />
                              {
                                (additionalDatesErrors[index] && additionalDatesErrors[index].title) &&
                                <span style={{ fontSize: "11px", color: "#dc4a4a" }}>{additionalDatesErrors[index].title}</span>
                              }
                            </Box>
                          </Grid>
                          <Grid item xs={12} md={6} >
                            <div style={{ display: "flex", gap: "10px" }}>
                              <Box className={classes.flexColumn} sx={{ gap: 5, flex: 1 }} style={{ border: "none", padding: 0, marginTop: "0px" }}>
                                <BasicInput
                                  fullWidth
                                  type='date'
                                  style={{color:`${(
                                    !additionalDate.value) ?  
                                    placeholderColor : activeColor }`
                                    }}
                                  value={additionalDate.value}
                                  onChange={(event) => { handleChangeInputField('value', event.target.value, index) }}
                                />
                                {
                                  (additionalDatesErrors[index] && additionalDatesErrors[index].value) &&
                                  <span style={{ fontSize: "11px", color: "#dc4a4a" }}>{additionalDatesErrors[index].value}</span>
                                }
                              </Box>
                              <IconButton
                                size='small'
                                className=""
                                style={{ marginLeft: "5px" }}
                                onClick={() => {
                                  removeInputField(index);
                                }}
                              >
                                <DeleteForever color='error' />
                              </IconButton>
                            </div>
                          </Grid>
                        </>
                      ))
                    }
                  </Grid>
                  {/* // Dates */}

                </Box>
              </Box>

            </div>
          )
          }

          {
            currentContact >= contactLimit && (
              <Upgrade
                isLoading={isLoading}
                handleChange={() => props.onClose()}
              />
            )
          }

          {
            submittingContact && (
              <GlobalAddContactModalSkeleton/>
            )
          }
        </Fragment>
      )}

      {isLoading && <GlobalAddContactModalSkeleton/>}
    </GlobalModalV2>
  );
};

const mapStateToProps = (state) => {
  return {
    contact: state.addContactReducer.contact,
    userTagList: state.addContactReducer.userTagListAddContact,
    storedSourceList: state.addContactReducer.sourceListAddContact,
    storedCustomField: state.addContactReducer.userCustomFieldsAddContact,
    assignedContactListInfo: state.addContactReducer.assignedContactListInfo,
    contactListParams: state.addContactReducer.contactListParams,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserTagList: (params, callback) => dispatch(getUserTagList(params, callback)),
    storeUserTagList: (params) => dispatch(setUserTagList(params)),
    fetchUserSourceList: (params, callback) => dispatch(getUserSourceList(params, callback)),
    storeUserSourceList: (params) => dispatch(setUserSourceList(params)),
    fetchUserCustomFields: (params, callback) => dispatch(getUserCustomFieldList(params, callback)),
    storeUserCustomFields: (params) => dispatch(setUserCustomFieldList(params)),
    storeUserCustomFieldsNew: (params) => dispatch(storeUserCustomFieldsListNew(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddContactModal);

export const renderEachCustomField = (data, index, onChange, previousData) => {
  const placeholderColor = "rgb(8 40 82 / 42%)";
  const activeColor = "#36454F";
  let type_id = data.type_id;
  let _values =
    typeof previousData[index] !== "undefined" && previousData[index] != null
      ? typeof previousData[index].value !== "undefined"
        ? type_id === CustomFieldType.CHECKBOX
          ? previousData[index].value.split(",")
          : previousData[index].value
        : ""
      : "";

  // Date normalization from DynamicInputField
  const normalizeDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";
    dateStr = dateStr.trim();

    // Format: YYYY-MM-DD
    if (dateStr.includes("-")) {
      let [year, month, day] = dateStr.split("-");

      year = year.slice(-4); // ✅ last 4 digits
      month = month.padStart(2, "0");
      day = day.padStart(2, "0");

      return `${month}/${day}/${year}`;
    }

    // Format: MM/DD/YYYY (or longer year)
    if (dateStr.includes("/")) {
      let [month, day, year] = dateStr.split("/");

      if (!year || !month || !day) return "";

      year = year.slice(-4); // ✅ last 4 digits
      month = month.padStart(2, "0");
      day = day.padStart(2, "0");

      return `${month}/${day}/${year}`;
    }
    return "";
  };


  // Datetime normalization from DynamicInputField
  const normalizeDateTime = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") return "";
    dateTimeStr = dateTimeStr.trim();

    const [datePart, timePartRaw] = dateTimeStr.split("T");
    if (!datePart || !timePartRaw) return "";

    const formattedDate = normalizeDate(datePart);
    if (!formattedDate) return "";

    const timePart = timePartRaw.split(".")[0]; // Remove milliseconds if present
    return `${formattedDate} ${timePart}`;
  };

  // Convert to ISO date for display (YYYY-MM-DD)
   function convertToISODate(input) {
     if (!input || typeof input !== "string") {
       // console.warn("Invalid input: Not a string or is empty.");
       return "";
     }

     // Check if already in ISO format
     const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
     if (isoRegex.test(input)) {
       // console.log("Input is already in ISO format.");
       return input;
     }

     // Match MM/DD/YYYY or M/D/YYYY
     const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
     const match = input.match(regex);

     if (!match) {
       // console.warn("Input does not match MM/DD/YYYY format.");
       return "";
     }

     let [_, mm, dd, yyyy] = match;

     // Pad month and day with leading zeros
     const paddedMM = mm.padStart(2, "0");
     const paddedDD = dd.padStart(2, "0");

     const isoFormatted = `${yyyy}-${paddedMM}-${paddedDD}`;
     console.log("Converted to ISO format:", isoFormatted);
     return isoFormatted;
   }


  // Convert to ISO datetime for display (YYYY-MM-DDTHH:mm)
  function convertToISODatetime(input) {
    if (!input || typeof input !== "string") return "";

    input = input.trim();
    console.log("Converted to ISO format:", input);

    // Case 1: Already ISO-like with time (YYYY-MM-DDTHH:mm or YYYY-MM-DD HH:mm)
    const isoRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/;
    if (isoRegex.test(input)) {
      const [datePart, timePart] = input.split(/[ T]/);
      const [year, month, day] = datePart.split("-");
      const [hh, min] = timePart.split(":");
      return `${year}-${month}-${day}T${hh.padStart(2, "0")}:${min.padStart(
        2,
        "0"
      )}`;
    }

    // Case 2: MM/DD/YYYY HH:mm (or with seconds)
    const fullDateTimeRegex =
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
    const fullMatch = input.match(fullDateTimeRegex);
    if (fullMatch) {
      const [_, mm, dd, yyyy, hh, min] = fullMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(
        2,
        "0"
      )}T${hh.padStart(2, "0")}:${min.padStart(2, "0")}`;
    }

    // Case 3: MM/DD/YYYY → default time to 00:00
    const usDateOnlyRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const usDateMatch = input.match(usDateOnlyRegex);
    if (usDateMatch) {
      const [_, mm, dd, yyyy] = usDateMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T00:00`;
    }

    // ✅ Case 4: YYYY-MM-DD (ISO date only) → default time to 00:00
    const isoDateOnlyRegex = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    const isoDateMatch = input.match(isoDateOnlyRegex);
    if (isoDateMatch) {
      const [_, yyyy, mm, dd] = isoDateMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T00:00`;
    }

    return ""; // Fallback if nothing matches
  }


  const handleOnChange = (e, self) => {
    let value = e.target.value;

    if (type_id === CustomFieldType.NUMERIC || type_id === CustomFieldType.ZIP_CODE) {
      onChange(value, index, data.id, data?.max_length);
    } else if (type_id === CustomFieldType.CHECKBOX) {
      let previous_value =
        typeof previousData[index] !== "undefined" && previousData[index] != null
          ? typeof previousData[index].value !== "undefined"
            ? previousData[index].value
            : ""
          : "",
        new_value = "";
      if (e.target.checked) {
        if (previous_value.trim() === "") {
          new_value = e.target.value;
        } else {
          new_value = previous_value + "," + e.target.value;
        }
      } else {
        if (previous_value.indexOf(e.target.value) !== -1) {
          let value_array = previous_value.split(",");
          value_array.forEach((each_data, each_index) => {
            if (each_data !== e.target.value) {
              if (new_value === "") {
                new_value += each_data;
              } else {
                new_value = new_value + "," + each_data;
              }
            }
          });
        }
      }
      onChange(new_value, index, data.id);
    } else if (type_id === CustomFieldType.DATE) {
      value = normalizeDate(value); // Store as MM/DD/YYYY
      onChange(value, index, data.id);
    } else if (type_id === CustomFieldType.DATETIME) {
      value = normalizeDateTime(value); // Store as MM/DD/YYYY HH:mm:ss
      onChange(value, index, data.id);
    } else if (type_id === CustomFieldType.RADIO) {
      onChange(value, index, data.id);
    } else {
      onChange(value, index, data.id);
    }
  };

  if (
    type_id === CustomFieldType.TEXT ||
    type_id === CustomFieldType.MULTILINE_TEXT ||
    type_id === CustomFieldType.NUMERIC ||
    type_id === CustomFieldType.DATE ||
    type_id === CustomFieldType.DATETIME ||
    type_id === CustomFieldType.PHONE ||
    type_id === CustomFieldType.ZIP_CODE ||
    type_id === CustomFieldType.WEBSITE ||
    type_id === CustomFieldType.CHECKBOX ||
    type_id === CustomFieldType.RADIO ||
    type_id === CustomFieldType.SELECT
  ) {
    return (
      <div
        className="input-field col s12 m12 custom_contact_field"
        key={`${type_id} ${index}`}
        style={{ marginBottom: 0, marginTop: "8px", paddingBottom: "8px" }}
      >
        {(type_id === CustomFieldType.TEXT || type_id === CustomFieldType.PHONE) && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                  <BasicInput
                      fullWidth
                      type="text"
                      id={`custom-field-${index}`}
                      value={previousData[index]?.value || ""}
                      placeholder={"Enter " + data?.title}
                      maxLength={data?.max_length}
                      onChange={(e) => handleOnChange(e)}
                  />
                }
                sx={{
                  '& .MuiInputBase-root': {
                      marginTop: 0,
                  },
                  '& input': {
                      border: 'none !important'
                  }
                }}
              />
        )}

        {type_id === CustomFieldType.MULTILINE_TEXT && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                    <textarea
                        rows="5"
                        className={"custom-field-textarea MuiInputBase-input"}
                        id={`custom-field-${index}`}
                        placeholder={"Enter " + data?.title}
                        onChange={(e) => handleOnChange(e)}
                        style={{
                            fontSize: "15px",
                            color: `${!previousData?.[index]?.value ? placeholderColor : activeColor}`
                        }}
                    >
                    {previousData?.[index]?.value}
                  </textarea>
                }
                sx={{
                    '& textarea': {
                        marginTop: 0,
                        border: 'none !important'
                    }
                }}
            />
        )}

        {(type_id === CustomFieldType.NUMERIC || type_id === CustomFieldType.ZIP_CODE) && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                    <BasicInput
                        fullWidth
                        type="number"
                        id={`custom-field-${index}`}
                        value={previousData?.[index]?.value}
                        placeholder={"Enter " + data?.title}
                        maxLength={data?.max_length}
                        pattern="[0-9]{11}"
                        onChange={(e) => handleOnChange(e)}
                    />
                }
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.DATE && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                    <BasicInput
                        fullWidth
                        type="date"
                        id={`custom-field-${index}`}
                        value={convertToISODate(_values)} // Display as YYYY-MM-DD
                        onChange={(e) => handleOnChange(e)}
                        style={{ color: `${!_values ? placeholderColor : activeColor}` }}
                    />
                }
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.DATETIME && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                    <BasicInput
                        fullWidth
                        type="datetime-local"
                        id={`custom-field-${index}`}
                        value={convertToISODatetime(_values)} // Display as YYYY-MM-DDTHH:mm
                        onChange={(e) => handleOnChange(e)}
                        style={{ color: `${!_values ? placeholderColor : activeColor}` }}
                    />
                }
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.WEBSITE && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                component={
                    <BasicInput
                        fullWidth
                        type="url"
                        id={`custom-field-${index}`}
                        value={previousData?.[index]?.value}
                        placeholder={"Enter " + data?.title}
                        maxLength={data?.max_length}
                        pattern="[0-9]{11}"
                        onChange={(e) => handleOnChange(e)}
                    />
                }
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.CHECKBOX && (
            <>
                <Typography variant="body1" style={{ left: "0", marginBottom: 1, position: "relative", height: "auto", fontWeight: "600", color: "#181f48" }}>
                    {data?.title}
                </Typography>
                <div className="check-box-input-groups">
                    <FormGroup row className="custom_check_box_container">
                        {data.default_values &&
                            Array.isArray(data.default_values) &&
                            data.default_values.map((each, each_index) => {
                                let isChecked = _values.indexOf(each) !== -1 ? true : false;
                                return (
                                    <FormControlLabel
                                        className="custom_check_box"
                                        control={
                                            <Checkbox
                                                checked={isChecked}
                                                onChange={handleOnChange}
                                                name={`${index}-${data.personalize_tag}[]`}
                                                value={each}
                                                style={{ padding: "12px" }}
                                            />
                                        }
                                        label={each}
                                    />
                                );
                            })}
                    </FormGroup>
                </div>
            </>
        )}

        {type_id === CustomFieldType.RADIO && (
            <>
                <Typography variant="body1" style={{ left: "0", marginBottom: 1, position: "relative", height: "auto", fontWeight: "600", color: "#181f48" }}>
                    {data?.title}
                </Typography>
                <div className="radio-button-input-groups">
                    <RadioGroup
                        row
                        aria-label={index + "-" + data.personalize_tag}
                        name={index + "-" + data.personalize_tag}
                        value={_values}
                        onChange={handleOnChange}
                    >
                        {data.default_values &&
                            Array.isArray(data.default_values) &&
                            data.default_values.map((each, each_index) => {
                                return (
                                    <FormControlLabel
                                        value={each}
                                        control={<Radio style={{ padding: "12px" }} />}
                                        label={each}
                                    />
                                );
                            })}
                    </RadioGroup>
                </div>
            </>
        )}

        {type_id === CustomFieldType.SELECT && (
          <select
            className="form-control h-100 d-block"
            placeholder={"Enter " + data.title}
            name={`add_contact_custom_field${data.personalize_tag}`}
            onChange={(e) => handleOnChange(e)}
            style={{ marginTop: 10, height: "2.5rem", fontSize: "15px", color: `${data.default_values ? placeholderColor : activeColor}` }}
          >
            <option value="" key={-1}>
              {data.title}
            </option>
            {data.default_values &&
              Array.isArray(data.default_values) &&
              data.default_values.map((each, each_index) => {
                if (
                  previousData[index] !== undefined &&
                  previousData[index] != null &&
                  previousData[index].value === each
                ) {
                  return (
                    <option
                      value={each}
                      key={`custom-select-${each_index}`}
                      selected
                    >
                      {each}
                    </option>
                  );
                } else
                  return (
                    <option value={each} key={`custom-select-${each_index}`}>
                      {each}
                    </option>
                  );
              })}
          </select>
        )}
      </div>
    );
  }

  return null;
};